import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { callApi } from "../callEndpoint";
import {
  specialistEndpoints,
  type SpecialistDropdownItem,
  type SpecialistProfile,
  type SpecialistsDropdownRequest,
  type SpecialistsListResponse,
  type SpecialistsRequest,
} from "../contracts/specialists.contract";

const PAGE_SIZE = 10;

export const useSpecialists = (params: SpecialistsRequest | null) => {
  const enabled = !!(params?.zipCode?.trim() && params?.specialty);
  return useInfiniteQuery({
    queryKey: ["specialists", params],
    queryFn: ({ pageParam = 0 }) =>
      callApi<SpecialistsListResponse>(specialistEndpoints.list, {
        params: { ...params!, take: PAGE_SIZE, skip: pageParam },
      }),
    getNextPageParam: (lastPage) =>
      lastPage.pagination.hasMore
        ? lastPage.pagination.skip + lastPage.pagination.take
        : undefined,
    initialPageParam: 0,
    enabled,
  });
};

export const useSpecialistsDropdown = (
  params: SpecialistsDropdownRequest | null,
) => {
  const enabled = !!(params?.specialty && params?.zipCode?.trim());
  return useQuery({
    queryKey: ["specialists-dropdown", params],
    queryFn: () =>
      callApi<SpecialistDropdownItem[]>(specialistEndpoints.dropdown, {
        params: params!,
      }),
    enabled,
  });
};

export const useSpecialistProfile = (
  specialistSlug: string | undefined,
  practiceSlug: string | undefined,
) =>
  useQuery({
    queryKey: ["specialist-profile", specialistSlug, practiceSlug],
    queryFn: () =>
      callApi<SpecialistProfile>(
        specialistEndpoints.profile(specialistSlug!, practiceSlug!),
      ),
    enabled: !!specialistSlug && !!practiceSlug,
    staleTime: 5 * 60_000,
  });
